import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { StyleGuide } from '~/components/style-guide/StyleGuide';

/**
 * Public design-system reference + UIKit gallery. Standalone (no app shell, no
 * auth) so it's always reachable for design review and onboarding.
 */
export const Route = createFileRoute('/style-guide')({
  component: StyleGuideRoute,
});

function StyleGuideRoute(): ReactNode {
  return <StyleGuide />;
}
